import {Platform} from 'react-native';
import axios from 'axios';
import {BASE_API} from './apis';

// Sent with every call to our backend so it knows which client is talking:
//   deviceType: 'ios' | 'android' | 'web'
//   version:    app version
export const APP_VERSION = '1.0';

export const APP_HEADERS = {
  deviceType: Platform.OS,
  version: APP_VERSION,
};

// Adds APP_HEADERS to a backend request. Calls to other hosts (Google APIs)
// are left alone.
export const addAppHeaders = config => {
  const url = `${config.baseURL || ''}${config.url || ''}`;
  if (url.startsWith(BASE_API)) {
    Object.entries(APP_HEADERS).forEach(([key, value]) => {
      if (typeof config.headers?.set === 'function') {
        config.headers.set(key, value);
      } else {
        config.headers = {...config.headers, [key]: value};
      }
    });
  }
  return config;
};

// The Redux slices call the global axios with full URLs; apiClient registers
// the same interceptor on its own instance.
axios.interceptors.request.use(addAppHeaders);
